import {
    TextField as AnvilTextField,
    TextFieldProps as AnvilTextFieldProps,
} from '@servicetitan/anvil2';
import { Controller, get, useFormContext } from 'react-hook-form';
import { FieldWrapperProps, valueFromString, valueToString } from './FieldWrapper';
import { useNumberFormat } from '@react-input/number-format';

type TextFieldProps = FieldWrapperProps<AnvilTextFieldProps>;

export const TextField = ({ type, description, onChange, ...props }: TextFieldProps) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const numericInputRef = useNumberFormat({
        // TODO: All number fields at the moment are currency, add props for these options as needed
        maximumFractionDigits: 2,
        groupDisplay: true,
    });

    const error = get(errors, props.name);
    return (
        <Controller
            name={props.name}
            control={control}
            render={({ field }) => (
                <AnvilTextField
                    {...props}
                    {...field}
                    type="text"
                    ref={type === 'number' ? numericInputRef : undefined}
                    description={error == null ? description : ''}
                    error={error != null ? error.message : undefined}
                    value={valueToString(field.value!)}
                    onChange={event => {
                        field.onChange(event);
                        onChange?.(event);
                    }}
                    onBlur={e => {
                        field.onChange(valueFromString(type!, e.currentTarget.value));
                        field.onBlur();
                    }}
                />
            )}
        />
    );
};
